interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div role="alert" className="flex flex-col items-start gap-2 rounded-xl border border-danger/30 bg-danger-soft p-4 text-sm text-red-200">
      <p>{message}</p>
      {onRetry && (
        <button type="button" onClick={onRetry} className="rounded-md border border-danger/40 px-3 py-1 text-xs font-semibold text-red-200 hover:bg-danger/10">
          Retry
        </button>
      )}
    </div>
  );
}
